import { render, staticRenderFns } from "./appImageUpload.vue?vue&type=template&id=28683d46&"
import script from "./appImageUpload.vue?vue&type=script&lang=js&"
export * from "./appImageUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports